import {Component, EventEmitter, Input, NgModule, Output} from '@angular/core';

export type SdDrawerMode = 'over' | 'push' | 'side';

@Component({
  selector: 'sd-sidenav, sd-drawer',
  exportAs: 'sdSidenav, sdDrawer',
  standalone: true,
  template: `<div class="sd-drawer-inner-container flex h-full flex-col overflow-hidden"><ng-content></ng-content></div>`,
  host: {
    class: 'sd-drawer sd-sidenav block h-full shrink-0 overflow-hidden bg-[var(--m365-bg-subtle,#f7f7fa)]',
    '[class.sd-sidenav--over]': 'mode === "over"',
    '[hidden]': '!opened',
  },
})
export class SdSidenav {
  @Input() mode: SdDrawerMode = 'side';
  @Input() position: 'start' | 'end' = 'start';
  @Input() fixedInViewport = false;
  @Input() fixedTopGap = 0;
  @Input() fixedBottomGap = 0;
  @Input()
  get opened(): boolean {
    return this._opened;
  }
  set opened(value: boolean) {
    if (this._opened === value) {
      return;
    }
    this._opened = value;
    this.openedChange.emit(value);
  }
  @Output() openedChange = new EventEmitter<boolean>();
  @Output() openedStart = new EventEmitter<void>();
  @Output() closedStart = new EventEmitter<void>();

  private _opened = true;

  open(): Promise<boolean> {
    this.opened = true;
    this.openedStart.emit();
    return Promise.resolve(true);
  }

  close(): Promise<boolean> {
    this.opened = false;
    this.closedStart.emit();
    return Promise.resolve(true);
  }

  toggle(): Promise<boolean> {
    return this.opened ? this.close() : this.open();
  }
}

export {SdSidenav as SdDrawer};

@Component({
  selector: 'sd-sidenav-content, sd-drawer-content',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'sd-sidenav-content flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden'},
})
export class SdSidenavContent {}

@Component({
  selector: 'sd-sidenav-container, sd-drawer-container',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'sd-sidenav-container flex h-full w-full overflow-hidden'},
})
export class SdSidenavContainer {
  @Input() hasBackdrop = false;
  @Input() autosize = false;
  @Output() backdropClick = new EventEmitter<void>();
}

@NgModule({
  imports: [SdSidenav, SdSidenavContent, SdSidenavContainer],
  exports: [SdSidenav, SdSidenavContent, SdSidenavContainer],
})
export class SdSidenavModule {}
